import type { JSX } from "react";
import { TaxonomyList } from "./TaxonomyList.js";
import { KIND_ORDER } from "./kindLabels.js";

interface Props {
  isOwner: boolean;
}

export function TaxonomyManager({ isOwner }: Props): JSX.Element {
  return (
    <div className="space-y-2">
      {KIND_ORDER.map((k, idx) => (
        <section
          key={k}
          className={
            idx === KIND_ORDER.length - 1
              ? ""
              : "pb-8 mb-2 border-b border-zinc-800"
          }
        >
          <TaxonomyList kind={k} isOwner={isOwner} />
        </section>
      ))}
    </div>
  );
}
